import { render } from "./ReportsPage.vue?vue&type=template&id=2156a0ae&scoped=true"
import script from "./ReportsPage.vue?vue&type=script&lang=js"
export * from "./ReportsPage.vue?vue&type=script&lang=js"

import "./ReportsPage.vue?vue&type=style&index=0&id=2156a0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2156a0ae"]])

export default __exports__